import { ConfiguratorData } from './density-map/'

/**  --- Exclude Levels ----
 * Optional
 * Array of refID's for buildingLevels which should not be rendered as map layers. 
 * 
 * The Getty Center geodata and boundary data includes the Tram and Arrival areas
 * There areas are a long way from the actual spaces we want to render on the map.
 * When included as part of the boundary calculations, the visitor density maps need
 * to zoom out a long way to fit everything in, and the UI is absurdly small.
 * 
 * Having an optional excludeLevels prop in the config data allow us to explicitly 
 * prevent specific levels from being including in the boundary calculation so that the
 * default map position and zoom level maximise the map size on the screen.
 * 
 */

const tramLevel = '017a88e2-2bd3-865d-378d-20802dd91869';
const arrivalLevel = '017a88e3-2f71-2055-9561-3430c4582c59';

export const configData: ConfiguratorData = {
  maxSpaceDensity: 4,
  excludeLevels: [tramLevel, arrivalLevel],
  camera: {
    pitch: 60,
  },
  scale: {
    minHeight: 0,
    maxHeight: 12,
    gap: 18,
    base: 0
  },
  layerStyles: [
    {
      fillHSL: [266, 90, 50],
      floorColor: "#333",
      floorOpacity: 1
    },
    {
      fillHSL: [266, 90, 50],
      floorColor: "#666",
      floorOpacity: 1
    },
    {
      fillHSL: [266, 90, 50],
      floorColor: "#999",
      floorOpacity: 1
    }
  ]
}
